<template>
    <div class="section">
        <User v-slot:user="{ user }">
            <div v-if="user">
                          <div class="section">
                              <div class="columns">
                                <div class="columns">
                                    <div class="column">
                                        <img name="profilePic" class="profilePic" src="../assets/profile_pic.png">
                                    </div>
                                    <div class="column">
                                        <tr><h3 style="color: violet;">{{ name.userName }}</h3></tr>
                                        <tr><audio :src="name.audioURL" controls></audio></tr>
                                    </div>
                                    <div v-if="user.uid == userId" class="column">
                                        
                                        <audio v-if="newAudio" :src="newAudioURL" controls></audio>
                                        <h5 v-else>Record Audio</h5>

                                        <button v-if="!recorder" @click="record()" class="button is-info">Record Voice</button>
                                        <button v-else @click="stop()" class="button is-danger">Stop</button>

                                        <br />

                                        <button
                                        :disabled="(!newMessageText && !newAudio) || loading"
                                        class="button is-success"
                                        type="text"
                                        @click="addMessage(user.uid)"
                                        >Send</button>
                                    </div>
                                </div>
                              </div>
                              <table>
      <td></td><td></td>
      </table>
                  
                                </div>
                
                <div class="section">
                    <div class="columns">
                        <div class="column">
                            <h3 style="color: violet;">Profile</h3>
                            <section class="container">
                                <article class="fullCard">
                                    {{name.text}}
                                        </article>
    </section>
                            <input v-if="user.uid == userId" v-model="newMessageText" class="input" />
                        </div>
                        <div class="column">
                                <h3 style="color: violet;">Articles</h3>
                            <MyArticles :uid="userId" />
                        </div>
                    </div>
                </div>
                

            </div>
            <Login v-else />
        </User>     
    </div>
</template>

<script>
import MyArticles from './MyArticles';
import User from './User.vue';
import Login from './Login';
import { db, storage } from '../firebase';


export default {
    components: {
        MyArticles,
        User,
        Login
    },
    data() {
        return {
            name: '',
            loading: false,
            newMessageText: '',
            newAudio: null,
            recorder: null
        }
    },
    computed: {
        userId() {
            return this.$route.params.uid;
        },
        userInfo() {
            return db.doc(`users/${this.userId}`);
        }
    },
    firestore() {
        return{
            name: this.userInfo
        };    
    },
      methods: {
    async addMessage() {

        this.loading = true;

        let audioURL = null;

        if (this.newAudio) {
          const storageRef = storage
            .ref('profile')
            .child(this.userId)
            .child('audio')
            .child('audio.wav');

            await storageRef.put(this.newAudio);

          audioURL = await storageRef.getDownloadURL();
        }


         await this.userInfo.update({
            text: this.newMessageText,
            createdAt: Date.now(),
            audioURL
        });

        this.loading = false; 
        this.newMessageText = '';
        this.newAudio = null;
    },
    async record() {
      this.newAudio = null;

      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false
      });

      const options = { mimeType: "audio/webm" };
      const recordedChunks = [];
      this.recorder = new MediaRecorder(stream, options);

      this.recorder.addEventListener("dataavailable", e => {
        if (e.data.size > 0) {
          recordedChunks.push(e.data);
        }
      });

      this.recorder.addEventListener("stop", () => {
        this.newAudio = new Blob(recordedChunks);
        console.log(this.newAudio);
      });

      this.recorder.start();
    },
    async stop() {
      this.recorder.stop();
      this.recorder = null;
    }
  }
}
</script>

<style>
    .profilePic{
        height: 195px;

    }
</style>